// ------------ Z-Index ----------- //

// General
export const indexSub = -1;
export const indexBump = 1;
export const index1 = 100;
export const index2 = 200;
export const index3 = 300;
export const index4 = 400;
export const index5 = 500;
export const index6 = 600;
export const index7 = 700;
export const index8 = 800;
export const index9 = 900;
export const index10 = 1000;

// Global
export const navHeader = index10;
